import { action, observable } from 'mobx'
import ConfigurationService from '@modules/wholesale/configurationSettings/services/ConfigurationService'
import { stores } from '@stores'
export class ConfigurationStore {
  configurationService = new ConfigurationService()

  // FIXME - Put in default configuration
  @observable configuration = {}
  // Use configurationService to fetch configuration and if not error assign it to this.configuration and return it
  @action
  fetchConfiguration = async () => {
    const latestConfiguration = await this.configurationService.getConfiguration()
    this.configuration = latestConfiguration
    return this.configuration
  }
  @action
  updateConfiguration = async configuration => {
    const updatedConfiguration = await this.configurationService.updateConfiguration(
      configuration
    )
    this.configuration = updatedConfiguration
    const { branding } = stores
    if (updatedConfiguration?.branding) {
      branding.setConfiguration(updatedConfiguration?.branding)
    }
    return this.configuration
  }
}
const store = new ConfigurationStore()
export default store
